var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistogram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 73,
    viewBox: "0 0 80 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 71.0408H77.6159H2ZM25.0135 31.589H34.8765V71.0408H25.0135V31.589ZM44.7394 34.8767H54.6024V71.0408H44.7394V34.8767ZM64.4653 21.7261H74.3283V71.0408H64.4653V21.7261ZM5.28765 54.6026H15.1506V71.0408H5.28765V54.6026Z",
    stroke: "#949494",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2876 41.4517L29.945 18.4381L49.6708 23.3696L71.0406 1.99988",
    stroke: "#949494",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1777 1.99988H71.0407V11.8628",
    stroke: "#949494",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistogram);
export default __webpack_public_path__ + "static/media/histogram.2e72ef417f93c4c757a57d78a7d93d49.svg";
export { ForwardRef as ReactComponent };